function parseKey (key: any, val: any): number {
    // detect negative index notation
    if (key[0] === '-' && Array.isArray(val) && /^-\d+$/.test(key)) {
        return val.length + parseInt(key, 10);
    }
    return key;
}

function parsePath (path: string, sep: string): string[] {
    if (path.indexOf('[') >= 0) {
        path = path.replace(/\[/g, '.').replace(/]/g, '');
    }
    return path.split(sep);
}

/**
 * Pick a value from an object using dot notation.
 */
export function pick(path: string, object: any): any {
    let key;
    const keys = parsePath(path, '.');
    for (let i = 0; i < keys.length; i++) {
        key = parseKey(keys[i], object);
        if (object && typeof object === 'object' && key in object) {
            if (i === (keys.length - 1)) {
                return object[key];
            } else {
                object = object[key];
            }
        } else {
            return undefined;
        }
    }
    return object;
}
